export default "__VITE_ASSET__kT30CPvV__"